export default [
  {
    name: 'unknown',
    icon: 'ggs-fa ggs-fa-times',
    color: 'ggs-clr__unknown',
    background: 'ggs-bg-clr__unknown'
  },
  {
    name: 'upload',
    icon: 'ggs-fa ggs-fa-user-o',
    color: 'ggs-clr__user',
    circle: 'ggs-icon__user-circle',
    stroke: 'ggs-icon__user-stroke',
    background: 'ggs-bg-clr__user'
  },
  {
    name: 'link',
    icon: 'ggs-fa ggs-fa-link',
    color: 'ggs-clr__link',
    background: 'ggs-bg-clr__link'
  },
  {
    name: 'email',
    icon: 'ggs-fa ggs-fa-envelope-o',
    color: 'ggs-clr__email',
    background: 'ggs-bg-clr__email'
  },
  {
    name: 'code',
    icon: 'ggs-fa ggs-fa-code',
    color: 'ggs-clr__code',
    background: 'ggs-bg-clr__code'
  },
  {
    name: 'globe',
    icon: 'ggs-fa ggs-fa-globe',
    color: 'ggs-clr__globe',
    background: 'ggs-bg-clr__globe'
  },
  {
    name: 'youtube',
    icon: 'ggs-fa ggs-fa-youtube-play',
    color: 'ggs-clr__youtube',
    background: 'ggs-bg-clr__youtube'
  },
  {
    name: 'instagram',
    icon: 'ggs-fa ggs-fa-instagram',
    color: 'ggs-clr__instagram',
    background: 'ggs-bg-clr__instagram'
  },
  {
    name: 'facebook',
    icon: 'ggs-fa ggs-fa-facebook',
    color: 'ggs-clr__facebook',
    background: 'ggs-bg-clr__facebook'
  },
  {
    name: 'vimeo',
    icon: 'ggs-fa ggs-fa-vimeo',
    color: 'ggs-clr__vimeo',
    background: 'ggs-bg-clr__vimeo'
  },
  {
    name: 'vine',
    icon: 'ggs-fa ggs-fa-vine',
    color: 'ggs-clr__vine',
    background: 'ggs-bg-clr__vine'
  },
  {
    name: 'soundcloud',
    icon: 'ggs-fa ggs-fa-soundcloud',
    color: 'ggs-clr__soundcloud',
    background: 'ggs-bg-clr__soundcloud'
  },
  {
    name: 'twitter',
    icon: 'ggs-fa ggs-fa-twitter',
    color: 'ggs-clr__twitter',
    background: 'ggs-bg-clr__twitter'
  },
  {
    name: 'pinterest',
    icon: 'ggs-fa ggs-fa-pinterest-p',
    color: 'ggs-clr__pinterest',
    circle: 'ggs-icon__pinterest-circle',
    stroke: 'ggs-icon__pinterest-stroke',
    background: 'ggs-bg-clr__pinterest'
  },
  {
    name: 'tumblr',
    icon: 'ggs-fa ggs-fa-tumblr',
    color: 'ggs-clr__tumblr',
    background: 'ggs-bg-clr__tumblr'
  }
]
